<template>
  <!-- <div class="appContainer profile-page"> -->
  <div class="appContainer profile-page">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('profile-page.header', { split: '/' }) }}</h1>
    </div>
    <v-row class="profile">
      <div class="wrapper-entry">
        <v-col cols="12" md="12" sm="12" lg="12">
          <table class="table-custom" border="0" cellspacing="0" cellpadding>
            <tbody>
              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('name')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="$t('profile-page.name', { split: '/' })"
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('name')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="name"
                    type="text"
                    class="input input-none"
                    :value="applicant !== null ? applicant.name : ''"
                    disabled
                  />
                </td>
                <td
                  class="avatar"
                  rowspan="5"
                  v-if="isShowBasicInformationField('img')"
                >
                  <div class="information">
                    <div class="img-box">
                      <img
                        :src="getImg"
                        alt
                        v-if="applicant !== null && applicant.img !== null"
                      />
                      <img :src="imgDefault" alt="" class="img-logo" v-else />
                    </div>
                    <p
                      v-html="
                        $t('profile-page.my-code-title', { split: '<br/>' })
                      "
                    ></p>
                    <h4>
                      {{ getApplicantEntry }}
                    </h4>
                  </div>
                </td>
                <td v-else></td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  isShowBasicInformationField('name_kana') &&
                  this.$i18n.locale === LANG_CODE_JAPANESE
                "
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="$t('profile-page.name_kana', { split: '/' })"
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('name_kana')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="name"
                    type="text"
                    class="input input-none"
                    :value="applicant !== null ? applicant.name_kana : ''"
                    disabled
                  />
                </td>
                <td v-if="!isShowBasicInformationField('img')"></td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('gender')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.gender', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('gender')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="name"
                    type="text"
                    class="input input-none"
                    :value="genderConvert"
                    disabled
                  />
                </td>
                <td v-if="!isShowBasicInformationField('img')"></td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('birthday')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.birthday', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('birthday')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="birthday"
                    type="text"
                    class="input input-none"
                    :value="birthdayFormatted"
                    disabled
                  />
                </td>
                <td v-if="!isShowBasicInformationField('img')"></td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('mail_address')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.email', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('mail_address')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="email"
                    type="text"
                    class="input input-none"
                    :value="applicant !== null ? applicant.mail_address : ''"
                    disabled
                  />
                </td>
                <td v-if="!isShowBasicInformationField('img')"></td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('phone_number')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.phone', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span
                    class="col-require text-right"
                    v-if="
                      template.participant_basic_info_type ===
                      this.EVENT_DEFAULT || isFieldRequired('phone')
                    "
                  >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="phone"
                    type="text"
                    class="input input-none"
                    :value="applicant !== null ? applicant.phone_number : ''"
                    disabled
                  />
                </td>
                <td class="border-bottom"></td>
              </tr>
              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('address')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.address1', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('area_id')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="area_id"
                    type="text"
                    class="input input-none"
                    :value="areaFormat()"
                    disabled
                  />
                </td>
                <td class="border-bottom"></td>
              </tr>
              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('address')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.address2', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('address')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="address"
                    type="text"
                    class="input input-none"
                    :value="applicant !== null ? applicant.address : ''"
                    disabled
                  />
                </td>
                <td class="border-bottom"></td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('hometown_id')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.place-of-birth', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('hometown_id')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="hometown"
                    type="text"
                    class="input input-none"
                    :value="homeTownFormat()"
                    disabled
                  />
                </td>
                <td class="border-bottom"></td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('facebook')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="$t('profile-page.facebook')"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('facebook')" >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="facebook"
                    type="text"
                    class="input input-none"
                    :value="applicant !== null ? applicant.facebook : ''"
                    disabled
                  />
                </td>
                <td class="border-bottom"></td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('time_zone')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('profile-page.timezone', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('time_zone')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="time_zone"
                    type="text"
                    class="input input-none"
                    :value="timezoneFormat()"
                    disabled
                  />
                </td>
                <td class="border-bottom"></td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </div>
    </v-row>

    <v-row>
      <v-col class="text-center">
        <v-btn
          class="btn-update"
          depressed
          color="#E8320D"
          @click="updateEvent"
          >{{ $t('component.button-edit', { split: '/' }) }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import '@/style/common.scss';
import { DEFAULT_LANGUAGE } from '@/constants/tran';
import { MALE, FEMALE, EVENT_DEFAULT } from '@/common/constants';

export default {
  data: (vm) => {
    return {
      time_zone: '',
      modal_birthday: false,
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      locale: 'vi',
      EVENT_DEFAULT,
      imgDefault:
        'data:image/png;base64,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'
    };
  },

  computed: {
    ...mapGetters({
      applicant: 'getBasicInfomation',
      m_event: 'getEventData',
      current_lang: 'getCurrentLanguage',
      template: 'getMTemplate'
    }),

    birthdayFormatted() {
      return this.formatDate(
        this.applicant !== null ? this.applicant.birthday : ''
      );
    },

    genderConvert() {
      if (this.applicant !== null && this.applicant.gender == MALE) {
        return this.$t('register-page.btn-gender.male', { split: '/' });
      } else if (this.applicant !== null && this.applicant.gender == FEMALE) {
        return this.$t('register-page.btn-gender.female', {
          split: '/'
        });
      } else {
        return this.$t('register-page.btn-gender.other', {
          split: '/'
        });
      }
    },
    getImg() {
      return this.applicant !== null ? this.applicant.img : null;
    }
  },

  watch: {
    applicant: function (val) {
      return val;
    }
  },

  methods: {
    areaFormat: function () {
      if (this.applicant && this.applicant.area_id) {
        const arr = this.m_area.filter(
          (ele) => ele.id === this.applicant.area_id
        );
        if (arr.length > 0) {
          return arr[0].area_name;
        } else return null;
      }
      return null;
    },
    updateEvent() {
      this.$emit('updateEvent');
    },
    timezoneFormat: function () {
      if (this.applicant && this.applicant.time_zone) {
        const arr = this.c_time_zone.filter(
          (ele) => ele.id === this.applicant.time_zone
        );
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      if (this.current_lang === DEFAULT_LANGUAGE)
        return `${year}/${month}/${day}`;
      else return `${day}/${month}/${year}`;
    },
    homeTownFormat() {
      if (this.applicant && this.applicant.hometown_id) {
        const arr = this.m_hometown.filter(
          (ele) => ele.id === this.applicant.hometown_id
        );
        if (arr.length > 0) {
          return arr[0].hometown_name;
        } else return null;
      }
    },
    isFieldRequired(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      if (modification && modification.hasOwnProperty('required')) {
        return modification.required;
      }
      const defaultRequired = [
        'name', 'name_en', 'gender', 'birthday', 'mail_address',
        're_mail_address', 'address', 'hometown_id', 'area_id', 'time_zone'
      ];
      if (this.m_template.participant_basic_info_type === this.EVENT_DEFAULT) {
        defaultRequired.push('phone_number');
      }
      return defaultRequired.includes(fieldName);
    }
  }
};
</script>

<style lang="scss">
.profile {
  display: flex !important;
  flex-direction: row;
  justify-content: center !important;

  margin-left: unset !important;
  margin-right: unset !important;
  width: 100% !important;
  .wrapper-entry {
    width: 80% !important;
  }
}
</style>
